import {centsToLocalizedString, toCentsFromMoney} from "../../../../../lib/Money.ts";
import {formatPeriodLabel} from "../../../../general/DateRangeInput/utils/dateRangeUtils.ts";
import type {ComparisonPeriod, ReportRow} from "../../types";
import {formatSignedCents, rowLabel} from "../../utils";
import type {LegalEntityType} from "../../../../../generated/enums.ts";

function balanceFooterLabel(balanceDiffCents: number): string {
    if (balanceDiffCents === 0) return "Balansverschil 0,00";
    const letter = balanceDiffCents < 0 ? "C" : "D";
    return `Balansverschil ${centsToLocalizedString(Math.abs(balanceDiffCents))} ${letter}`;
}

export function TableFooter({
    netResultRow,
    legalEntityType,
    comparisonPeriod,
    balanceDiffCents,
}: {
    netResultRow: ReportRow | null;
    legalEntityType: LegalEntityType;
    comparisonPeriod: ComparisonPeriod | null;
    balanceDiffCents: number;
}) {
    if (!netResultRow) return null;

    const comparisonValue =
        comparisonPeriod && netResultRow.comparison
            ? formatSignedCents(toCentsFromMoney(netResultRow.comparison.signed_net))
            : null;

    return (
        <div className="sticky bottom-0 z-[7] flex flex-wrap items-center justify-between gap-4 border-t-2 border-gray-900 bg-white px-4 py-2.5 rounded-b-lg">
            <div className="flex flex-wrap items-baseline gap-2.5 text-sm text-gray-500">
                <span>{rowLabel(netResultRow, legalEntityType)}</span>
                <b className="text-[15px] font-bold text-gray-900 tabular-nums">
                    {formatSignedCents(toCentsFromMoney(netResultRow.signed_net))}
                </b>
                {comparisonValue && comparisonPeriod && (
                    <span className="text-xs text-gray-400">
                        {formatPeriodLabel(comparisonPeriod.start_date, comparisonPeriod.end_date)}:{" "}
                        {comparisonValue}
                    </span>
                )}
            </div>
            <span className="inline-flex items-center rounded-full bg-gray-50 px-3 py-1 text-xs font-semibold text-gray-700">
                {balanceFooterLabel(balanceDiffCents)}
            </span>
        </div>
    );
}
